<template>
  <svg
    aria-hidden="true">
    <use 
      :xlink:href="`#icon-${iconClass}`"/>
  </svg>
</template>

<script>
export default {
  props: {
    iconClass: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
svg{
  width: 1.1em;
  height: 1.1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/SvgIcon.vue